
import { useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { ScrollArea } from "@/components/ui/scroll-area";
import { mockMessages } from "@/data/mockCustomerData";

import { MessageDetailDialog } from "@/components/customers/MessageDetailDialog";
import { MessageSquare } from "lucide-react";

interface CustomerMessagesTabProps {
  customerId: string;
  customer: any;
  onSendMessage: (phone: string, message: string, template?: string) => void;
}

export function CustomerMessagesTab({ customerId, customer, onSendMessage }: CustomerMessagesTabProps) {
  const messages = mockMessages.filter(message => message.customerId === customerId);
  const [selectedMessage, setSelectedMessage] = useState(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleSendMessage = (message: string, template?: string) => {
    onSendMessage(customer.phone, message, template);
  };

  const handleOpenMessageDetail = (message: any) => {
    setSelectedMessage(message);
    setIsDialogOpen(true);
  };

  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle>Histórico de Mensagens</CardTitle>
        </CardHeader>
        <CardContent>
          {messages.length === 0 ? (
            <div className="text-center py-8 text-gray-500">
              Nenhuma mensagem foi enviada para este cliente.
            </div>
          ) : (
            <div className="rounded-md border">
              <ScrollArea className="h-[300px]">
                <Table>
                  <TableHeader>
                    <TableRow>
                      <TableHead className="w-[140px]">Data</TableHead>
                      <TableHead className="w-[45%]">Mensagem</TableHead>
                      <TableHead className="w-[15%]">Template</TableHead>
                      <TableHead className="w-[15%]">Status</TableHead>
                    </TableRow>
                  </TableHeader>
                  <TableBody>
                    {messages.map((message) => (
                      <TableRow 
                        key={message.id} 
                        className="cursor-pointer hover:bg-gray-50"
                        onClick={() => handleOpenMessageDetail(message)}
                      >
                        <TableCell>
                          {new Date(message.date).toLocaleDateString('pt-BR', {
                            day: '2-digit',
                            month: '2-digit',
                            year: 'numeric',
                            hour: '2-digit',
                            minute: '2-digit'
                          })}
                        </TableCell>
                        <TableCell>
                          <div className="flex items-center gap-1">
                            <div className="break-words line-clamp-2">{message.content}</div>
                            <MessageSquare className="h-4 w-4 text-gray-400 flex-shrink-0 ml-1" />
                          </div>
                        </TableCell>
                        <TableCell>
                          {message.template ? message.template : "-"}
                        </TableCell>
                        <TableCell>
                          <div className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium 
                            ${message.status === 'Lida' ? 'bg-green-100 text-green-800' : 
                              message.status === 'Entregue' ? 'bg-blue-100 text-blue-800' : 
                              'bg-yellow-100 text-yellow-800'}`}>
                            {message.status}
                          </div>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </ScrollArea>
            </div>
          )}
        </CardContent>
      </Card>

      
      <MessageDetailDialog 
        message={selectedMessage} 
        open={isDialogOpen} 
        onOpenChange={setIsDialogOpen} 
      />
    </div>
  );
}
